import { LayoutGenerator } from "dependencies/emptyLayout/utils/layoutGenerator"
import { Tabs } from "materials/tabs/menus/model"
/**
 * 门户文本默认配置数据
 */
export const home = [
  {
    styleName: "自由布局",
    thumbnail: require("assets/images/leftMenu/layout/layout_1.png"),
    titleOptions: [
      {
        type: "top",
        elementOptions: [
          new Tabs({
            singleTabs: false,
            width: 280,
            height: 40,
            left: 0,
            top: 0,
            elementInLayoutId: 3,
            tabWidth: 50,
            tabHeight: 40,
            hoverBgColor: "rgba(61, 130, 242, 1)",
            textAlign: "center",
            searchType: "searchTabs",
            hoverMaxTabLength: 5,
            borderColor: "rgba(255,255,255,1)",
            hoverBorderColor: "rgba(255,255,255,1)",
            tabBackgroundColor: "rgba(255,255,255,1)"
          })
        ]
      },
      {
        type: "bottom",
        elementOptions: []
      },
      {
        type: "left",
        elementOptions: []
      },
      {
        type: "right",
        elementOptions: []
      }
    ],
    rows: new LayoutGenerator({
      // row的数量需与tab的数量同步
      rows: [
        {
          height: "100%",
          cols: [
            {
              width: "100%"
            }
          ]
        },
        {
          height: "100%",
          cols: [
            {
              width: "100%"
            }
          ]
        },
        {
          height: "100%",
          cols: [
            {
              width: "100%"
            }
          ]
        },
        {
          height: "100%",
          cols: [
            {
              width: "100%"
            }
          ]
        },
        {
          height: "100%",
          cols: [
            {
              width: "100%"
            }
          ]
        }
      ]
    }).rows
  }
]

/**
 * 大屏文本默认配置数据
 */
export const bs = [{}]

/**
 * app自由布局默认配置数据
 */
export const appHome = [
  {
    styleName: "自由布局",
    thumbnail: require("assets/images/leftMenu/layout/layout_1.png"),
    titleOptions: [
      {
        type: "top",
        elementOptions: [
          new Tabs({
            singleTabs: false,
            width: 280,
            height: 40,
            left: 0,
            top: 0,
            elementInLayoutId: 3,
            tabWidth: 50,
            tabHeight: 40,
            hoverBgColor: "rgba(61, 130, 242, 1)",
            textAlign: "center",
            searchType: "searchTabs",
            hoverMaxTabLength: 5,
            borderColor: "rgba(255,255,255,1)",
            hoverBorderColor: "rgba(255,255,255,1)",
            tabBackgroundColor: "rgba(255,255,255,1)"
          })
        ]
      },
      {
        type: "bottom",
        elementOptions: []
      },
      {
        type: "left",
        elementOptions: []
      },
      {
        type: "right",
        elementOptions: []
      }
    ],
    rows: new LayoutGenerator({
      // row的数量需与tab的数量同步
      rows: [
        {
          height: "100%",
          cols: [
            {
              width: "100%"
            }
          ]
        },
        {
          height: "100%",
          cols: [
            {
              width: "100%"
            }
          ]
        },
        {
          height: "100%",
          cols: [
            {
              width: "100%"
            }
          ]
        },
        {
          height: "100%",
          cols: [
            {
              width: "100%"
            }
          ]
        },
        {
          height: "100%",
          cols: [
            {
              width: "100%"
            }
          ]
        }
      ]
    }).rows
  }
]
